import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let WeaponProperties = class WeaponProperties extends VuexModule {
    constructor() {
        super(...arguments);
        this.weaponProperties = [];
        this.cachedVersion = 0;
    }
    async fetchWeaponProperties() {
        const { data: weaponProperties, cachedVersion } = await fetchFromCache(this, 'weaponProperties', 'weaponProperty');
        return { weaponProperties, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['weaponProperties', 'cachedVersion'] })
], WeaponProperties.prototype, "fetchWeaponProperties", null);
WeaponProperties = __decorate([
    Module({ namespaced: true, name: 'weaponProperties' })
], WeaponProperties);
export default WeaponProperties;
